import { FC } from 'react';
import type { ImageIntentContext } from '../../../../utils/imageIntentReporter';
import useImageIntentSaveShortcut from './useImageIntentSaveShortcut';

export interface ImageIntentSaveShortcutProps {
  // The surface Cmd/Ctrl+S is credited to while this is mounted, and its
  // gallery (all three fields, or NO_IMAGE_INTENT_GALLERY for none, when the
  // Redux gallery may not be the screen's; otherwise the hook fills it in).
  context: ImageIntentContext & { surface: string };
}

// useImageIntentSaveShortcut as a component, for the legacy class components
// (which cannot call hooks) whose previews are IntentPreviewImages; those
// register no surface of their own (one image per registration would credit
// the keystroke to whichever registered last). Render it once per screen,
// beside the previews. It renders nothing. A function component calls the
// hook directly instead.
const ImageIntentSaveShortcut: FC<ImageIntentSaveShortcutProps> = ({
  context,
}) => {
  useImageIntentSaveShortcut(context);
  return null;
};

export default ImageIntentSaveShortcut;
